// extracted by mini-css-extract-plugin
module.exports = {"itemWrapper":"styles_itemWrapper__54mBQ","listItem":"styles_listItem__DVB6X"};